import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import styles from './OmniStartDevSection.module.less';
import o1Reflect from 'assets/img/o1-reflect.png';
import loginConfig from '../../../auth/loginConfig';

export default function OmniStartDevSection() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.OmniStartDevSectionBackground}>
				<div className={styles.OmniStartDevSectionContainer}>
					<img
						src={o1Reflect}
						alt="Omni One with reflection"
						className={styles.OmniStartDevSectionImg}
					/>
					<div className={styles.OmniStartDevSectionText}>
						Omni One enables players to experience your VR content in an
						exciting new way. Let players walk and run around freely inside your
						game, with 360-degree movement at an analog speed that matches their
						physical movement on the Omni.
					</div>
					<div
						onClick={() =>
							loginWithRedirect({
								...loginConfig,
								redirectUri: `${window.location.origin}/projects`,
							})
						}
					>
						<div className={styles.OmniStartDevSectionButton}>
							Start Developing
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
